import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { settingsContainerSelector } from 'redux/selectors/interactive_video_creation'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import VideoSettingsModal from 'views/modals/video_settings_modal'

class InteractiveVideoSettingsModalContainer extends PureComponent {

	render() {
		return (
			<VideoSettingsModal
				closeModalHandler={this.props.actions.closeVideoSettings}
				grades={this.props.grades}
				gradeIds={this.props.selectedGrades}
				subjects={this.props.subjects}
				subjectId={this.props.selectedSubject}
				credits={this.props.credits}
				videoTitle={this.props.videoTitle}
				submitHandler={this.props.actions.saveVideoSettings}
				canEditSupportSettings={this.props.canEditSupportSettings}
				onPosterPicked={this.props.actions.uploadPosterPicked}
				onPosterError={this.props.actions.uploadPosterError}
				onTranscriptPicked={this.props.actions.uploadTranscriptPicked}
				onTranscriptError={this.props.actions.uploadTranscriptError}
				onQuestionPicked={this.props.actions.uploadQuestionPicked}
				onQuestionError={this.props.actions.uploadQuestionError}
				onSaveCredits={this.props.actions.uploadCredits}
				shouldAutoselectTitle={this.props.shouldAutoselectTitle }
			/>
		)
	}

}

function mapStateToProps(state) {
	return settingsContainerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeVideoSettings: interactiveVideoActions.closeVideoSettings,
		saveVideoSettings: interactiveVideoActions.saveVideoSettings,
		uploadPosterPicked: interactiveVideoActions.uploadPosterPicked,
		uploadPosterError: interactiveVideoActions.uploadPosterError,
		uploadTranscriptPicked: interactiveVideoActions.uploadTranscriptPicked,
		uploadTranscriptError: interactiveVideoActions.uploadTranscriptError,
		uploadQuestionPicked: interactiveVideoActions.uploadQuestionPicked,
		uploadQuestionError: interactiveVideoActions.uploadQuestionError,
		uploadCredits: interactiveVideoActions.uploadCredits,
	}, dispatch)
}

InteractiveVideoSettingsModalContainer.propTypes = {
	shouldAutoselectTitle: PropTypes.bool,
	modalName: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		closeVideoSettings: PropTypes.func.isRequired,
		saveVideoSettings: PropTypes.func.isRequired,
		uploadPosterPicked: PropTypes.func.isRequired,
		uploadPosterError: PropTypes.func.isRequired,
		uploadTranscriptPicked: PropTypes.func.isRequired,
		uploadTranscriptError: PropTypes.func.isRequired,
		uploadQuestionPicked: PropTypes.func.isRequired,
		uploadQuestionError: PropTypes.func.isRequired,
		uploadCredits: PropTypes.func.isRequired,
	}),
	videoTitle: PropTypes.shape({
		value: PropTypes.string,
		error: PropTypes.string,
	}),
	credits: PropTypes.string.isRequired,
	selectedSubject: PropTypes.number,
	subjects: PropTypes.array,
	selectedGrades: PropTypes.array,
	grades: PropTypes.array,
	canEditSupportSettings: PropTypes.bool,
}

InteractiveVideoSettingsModalContainer.defaultProps = {
	shouldAutoselectTitle: false,
	videoTitle: {
		value: '',
		error: '',
	},
	selectedSubject: 0,
	subjects: [],
	selectedGrades: [],
	grades: [],
	canEditSupportSettings: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	InteractiveVideoSettingsModalContainer
)

export { InteractiveVideoSettingsModalContainer }
